import { render, staticRenderFns } from "./PromodevCookieslaw.vue?vue&type=template&id=14068243&scoped=true&"
import script from "./PromodevCookieslaw.vue?vue&type=script&lang=js&"
export * from "./PromodevCookieslaw.vue?vue&type=script&lang=js&"
import style0 from "./PromodevCookieslaw.vue?vue&type=style&index=0&id=14068243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14068243",
  null
  
)

export default component.exports